/**
 * @generated SignedSource<<946336762d57cd710831a5eb5e1f2455>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EditNameScreenMutation$variables = {
  name: string;
};
export type EditNameScreenMutation$data = {
  readonly me: {
    readonly setName: {
      readonly id: string;
      readonly name: string;
    };
  };
};
export type EditNameScreenMutation = {
  response: EditNameScreenMutation$data;
  variables: EditNameScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MeMutation",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "setName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditNameScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditNameScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "153051a2e9940936ef209d799645e1df",
    "id": null,
    "metadata": {},
    "name": "EditNameScreenMutation",
    "operationKind": "mutation",
    "text": "mutation EditNameScreenMutation(\n  $name: String!\n) {\n  me {\n    setName(name: $name) {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "32c48d4dfb5b0e40fc52e6d5752a825f";

export default node;
